import * as React from 'react';
import { LabSimAppUrl } from '../Environment';

interface IDemoAccessProps {

}

interface IDemoAccessState {
    tether?: string;
}

export default class DemoTestLive extends React.PureComponent<IDemoAccessProps, IDemoAccessState> {
    constructor(props: IDemoAccessProps) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        window.onmessage = (e: MessageEvent) => {
            window.location.assign("https://labsimapp.testout.com");
        }
        let tether = encodeURIComponent(btoa(`{"login":"demoaccess_04d52772-c321-4bdc-bf13-02bc7661dde1","pHash":"0d15831472b6f872b1c8f112b6daa3b39ea69d3e111d87676b21f22794e6b675","source":"${window.location.protocol}//${window.location.host}","sales_contact":""}`));
        this.setState({ tether: `https://labsimapp.testout.com/?tetheredstart=${tether}` });
    }

    render() {
        return <div>
            <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <iframe src={this.state.tether} style={{ "display": "none" }} />
        </div>;
    }
}